export default __webpack_public_path__ + "static/media/reactFigma.27700483.png";